module.exports = __webpack_public_path__ + "static/media/sunny.a42608eb.svg";